import { RouteComponentProps, withRouter } from "react-router";
import Auth from "./auth";

export type IProps = RouteComponentProps<any>;

export default withRouter(Auth);
